<template>
  <div class="fb-set-thanks">
    <div ref="image" class="image">
      <div class="man"></div>
      <div class="mount"></div>
      <div class="cloud"></div>
    </div>
    <div class="fb-set-thanks-text">
      <h1 ref="label">Submitted!</h1>
      <p>Your submission has been saved and sent.</p>
      <div class="fb-actions">
        <md-button @click="goBack" class="md-raised md-primary fb-next">View submission</md-button>
        <md-button @click="goTo('/')" class="md-secondary fb-prev">Back to Home</md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SetThanks",
  props: ["routeName", "nid"],
  data() {
    return {
      page: [],
      id: 0,
      learner: "",
    };
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    },
    goBack() {
      this.goTo("/strategy/" + this.id + "/go");
      //this.$emit("back-to-go");
    },
  },
  created() {
    this.page = window.location.pathname.split("/")[1];
    this.id = window.location.pathname.split("/")[2];
  },
  mounted() {
    let learnerUuid = window.drupalSettings.learner_uuid;
    let learners = window.drupalSettings.learners;
    for (let item in learners) {
      if (learners[item].value === learnerUuid) {
        this.learner = learners[item].label;
      }
    }

    this.$refs["image"].classList.add("animated");
    this.$refs["label"].classList.add("animated");
    setTimeout(() => {
      this.$refs["image"].classList.remove("animated");
      this.$refs["label"].classList.remove("animated");
    }, 200);
  },
  activated() {
    this.$refs["image"].classList.add("animated");
    this.$refs["label"].classList.add("animated");
    setTimeout(() => {
      this.$refs["image"].classList.remove("animated");
      this.$refs["label"].classList.remove("animated");
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.fb-set-thanks {
  position: relative;
  text-align: center;
  @media all and (max-width: $breakpoint-medium) {
    min-height: 650px;
  }
  @media all and (min-width: $breakpoint-medium) {
    margin-top: 16px;
  }
  background-color: #e9f8ff;
  overflow: hidden;
  .image {
    margin-top: 100px;
  }
  .animated {
    .man {
      top: 125px;
    }
  }
  .man {
    transition: 0.3s;
    background-image: url("../assets/skydiving_man.svg");
    height: 110px;
    width: 110px;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 50%;
    margin-left: -55px;
    top: 40px;
    @media all and (max-width: $breakpoint-medium) {
      background-size: 60px;
      top: 18px;
    }
  }
  .mount {
    background-image: url("../assets/mount.svg");
    height: 134px;
    background-position: center bottom;
    background-size: 170px;
    margin-bottom: -20px;
    background-repeat: no-repeat;
    @media all and (max-width: $breakpoint-medium) {
      height: 90px;
      background-size: 140px;

      margin-bottom: -35px;
    }
  }
  .cloud {
    background-image: url("../assets/cloud.svg");
    height: 130px;
    background-position: center bottom -2px;
    background-repeat: no-repeat;
    background-size: 100%;
    @media all and (max-width: 381px) {
      height: 50px;

      background-size: 130%;
    }
    @media all and (max-width: $breakpoint-medium) {
      height: 95px;
      background-position: bottom -2px center;
    }
  }
  .fb-set-thanks-text {
    background-color: #ffffff;
  }
  .fb-actions {
    padding-top: 50px;
    padding-bottom: 20px;
    max-width: 300px;
    width: 100%;
    display: flex;
    flex-direction: column;
    > button {
      margin: 10px 0 !important;
    }
    margin: 0 auto;
    @media all and (max-width: $breakpoint-medium) {
      padding-top: 50px;
    }
    &::after {
      clear: both;
      content: "";
      display: block;
    }
    .fb-prev {
      color: $blue-active;
      float: left;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 18px;
        height: 40px;
      }
    }
    .fb-next {
      float: right;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
        height: 40px;
      }
      margin-right: 14px;
    }
  }
  flex-direction: column;
  display: flex;
  justify-content: flex-end;
  color: rgb(60, 60, 60);
  font-family: $font-filson-soft;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  h1 {
    color: rgb(60, 60, 60);
    font-family: $font-filson-soft;
    font-size: 36px;
    line-height: 54px;
    transition: 0.3s cubic-bezier(0.42, 0, 0.68, 1.52);
    @media all and (max-width: $breakpoint-medium) {
      margin: 0;
    }
    &.animated {
      transform: scale(0.5);
    }
  }
  a:not(.md-button) {
    font-family: $font-source-sans-pro;
    color: rgb(60, 60, 60);
    text-decoration: underline;
    font-weight: 300;
    &:hover {
      color: rgb(60, 60, 60);
    }
  }

  min-height: 600px;
  border-radius: 20px;
  margin: 0px;
  width: auto;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
